<template>
  <span v-if="isPrint" class="print-input">{{ data }}</span>
  <ml-input v-else-if="readonly" v-model="data" style="color: red" readonly class="w-full flex-1" />
  <vs-select v-else ref="select" v-model="data" autocomplete :disabled="disabled" :placeholder="placeholder" @input-change="inputChange">
    <fragment>
      <vs-select-item v-for="(option, idx) in newOptions" :key="`${idx}-${option.value}`"
                      :value="option.value" :text="option.text || option.value"/>
    </fragment>
  </vs-select>
</template>

<script>
export default {
  name: "CustomOptionSelector",
  props: {
    value: String | Number,
    options: Array,
    disabled: Boolean,
    readonly: Boolean,
    isPrint: Boolean,
    addableOption: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: "선택",
    },
    // 직접 입력 가능한 텍스트의 최대 길이
    max: {
      type: Number,
      default: 100,
    }
  },
  data() {
    return {
      data: this.value,
      custom: '',
    };
  },
  computed: {
    newOptions () {
      const result = this.options.map((option) => {
        if (typeof option === 'object') return option;
        else {
          return {
            value: option,
            text: option,
          };
        }
      });

      if (this.custom) {
        // 만약 result.value 중에 "직접입력"이 포함된 경우, 제거하고 추가한다.
        const customIndex = result.findIndex((option) => option.value.indexOf('직접입력') > -1);
        if (customIndex > -1) {
          result.splice(customIndex, 1);
        }

        result.push({
          value: this.custom,
          text: this.custom,
        });
      }

      return result;
    },
  },
  watch: {
    value() {
      this.data = this.value;
    },
    data(value) {
      // 만약 value 값이 options 내에 있다면, this.custom = '' 로 초기화한다.
      const isExist = this.options.some((option) => {
        if (typeof option === 'object') {
          return option.value === value;
        } else {
          return option === value;
        }
      });
      if (isExist) {
        this.custom = '';
      } else {
        this.custom = value;
      }

      // 만약 value 값에 "직접입력" 이 포함되어 있다면 this.$ref.select.$el.querySelector('input').select() 를 실행한다.
      if (value.indexOf('직접입력') > -1) {
        this.$nextTick(() => {
          this.$refs.select.$el.querySelector('input').select();
        });
      }

      this.$emit("input", this.data);
    },
  },
  mounted() {
    if (!this.value) {
      this.data = "";
      this.$emit("input", this.data);
    }
  },
  methods: {
    inputChange(event) {
      let value = event.target.value;
      if (this.addableOption) {
        // 만약 value 값이 options 내에 있다면, this.custom = '' 로 초기화한다.
        const isExist = this.options.some((option) => {
          if (typeof option === 'object') {
            return option.value === value;
          } else {
            return option === value;
          }
        });

        // max 길이보다 길 경우, max 길이만큼 자른다.
        if (this.max > 0 && value.length > this.max) {
          value = value.slice(0, this.max);
          event.target.value = value;
        }

        if (isExist) {
          this.custom = '';
        } else {
          this.custom = value;
        }
        this.$emit("input", value);
      }
    }
  },
};
</script>

<style scoped></style>
